import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const textVersion = (state: RootState) => state.params.textVersion;
const code = (state: RootState) => state.params.code;

export const hasTextTranslation = createSelector(textVersion, text => text !== undefined);
export const getCode = createSelector(code, c => c);
